import type { InlineEditSaveStatus } from '@shared/constants/inline-edit.constants';

export const ACTIVITY_NAME_MAX_LENGTH = 255;
export const ACTIVITY_DESCRIPTION_MAX_LENGTH = 1000;
export const ACTIVITY_INSTRUCTION_STEP_MAX_LENGTH = 5000;

export type ActivityDetailEditableField =
  | 'description'
  | 'duration'
  | 'grade'
  | 'instructions'
  | 'locations'
  | 'name'
  | 'sections'
  | 'subject'
  | 'subtopic'
  | 'subtype'
  | 'tools'
  | 'topic'
  | 'type'
  | 'visibility'
  | 'workform';

export type ActivityDetailFieldSaveStatuses = Record<ActivityDetailEditableField, InlineEditSaveStatus>;

export const INITIAL_ACTIVITY_DETAIL_FIELD_SAVE_STATUSES: ActivityDetailFieldSaveStatuses = {
  name: 'idle',
  description: 'idle',
  instructions: 'idle',
  locations: 'idle',
  sections: 'idle',
  duration: 'idle',
  subject: 'idle',
  grade: 'idle',
  type: 'idle',
  subtype: 'idle',
  subtopic: 'idle',
  tools: 'idle',
  topic: 'idle',
  visibility: 'idle',
  workform: 'idle',
};

/**
 * Per-field generation counters initialized to 0 for every editable detail field.
 *
 * @returns The result of this operation.
 */
export function createInitialActivityDetailFieldSaveGenerations(): Record<ActivityDetailEditableField, number> {
  return Object.fromEntries(
    (Object.keys(INITIAL_ACTIVITY_DETAIL_FIELD_SAVE_STATUSES) as ActivityDetailEditableField[]).map((field) => [
      field,
      0,
    ]),
  ) as Record<ActivityDetailEditableField, number>;
}
